export default angular.module("KhSidebar", []);